import {ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AbstractListView} from "../../../../core/visbos-core/ui/components/abstract-list-view";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {MedicineAuthFormComponent} from "../../../withdrawal/medicine-auth-form/medicine-auth-form.component";
import {Stock} from "../../../../shared/view-model/stock";
import {StockService} from "../../../services/stock.service";
import {FetchStocksInDepotsQuery} from "../../../../shared/graphql/graphql.types";
import {ApolloQueryObservable} from "apollo-angular";
import {combineLatest, debounceTime, distinctUntilChanged, switchMap} from "rxjs/operators";
import * as _ from "lodash";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {Observable} from "rxjs/Observable";
import {empty} from "rxjs/observable/empty";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

export function unequalTo(targetCtrlPath: string): ValidatorFn {
  return (srcCtrl: AbstractControl): { [key: string]: any } => {

    const targetCtrl = srcCtrl.root.get(targetCtrlPath);
    if (!srcCtrl || !targetCtrl) {
      return null;
    }

    const sourceValue = srcCtrl.value;
    const targetValue = targetCtrl.value;

    if (sourceValue == targetValue) {
      return {'valuesNotUnequal': true};
    } else {
      return null;
    }
  };
}

export function requiredIfOtherFieldNotNull(targetCtrlPath: string): ValidatorFn {
  return (srcCtrl: AbstractControl): { [key: string]: any } => {

    const targetCtrl = srcCtrl.parent ? srcCtrl.parent.get(targetCtrlPath) : null;

    if (!targetCtrl) {
      console.error("Did not find target control '" + targetCtrlPath + "'!", [srcCtrl]);
      return null;
    }

    if (!targetCtrl.value) {
      return null;
    }

    const sourceValue = srcCtrl.value;

    if (!sourceValue) {
      return {'required': true};
    } else {
      return null;
    }
  };
}

export function requiredIfOtherFieldNotNullReverse(srcCtrlPath: string): ValidatorFn {
  return (srcCtrl: AbstractControl): { [key: string]: any } => {

    const targetCtrl = srcCtrl.parent ? srcCtrl.parent.get(srcCtrlPath) : null;

    if (!targetCtrl) {
      console.error("Did not find target control '" + srcCtrlPath + "'!", [srcCtrl]);
      return null;
    }

    targetCtrl.updateValueAndValidity();

  };
}

@Component({
  selector: 'vb-move-stocks-list',
  templateUrl: './move-stocks-list.component.html',
  styleUrls: ['./move-stocks-list.component.css']
})
export class MoveStocksListComponent extends AbstractListView implements OnInit {

  public rowClassProxy = (row) => this.markRowAsDanger.apply(this, [row]);

  @ViewChild('amountTmpl')
  amountTmpl: TemplateRef<any>;

  @ViewChild('targetStockTmpl')
  targetStockTmpl: TemplateRef<any>;

  err = {
    valuesNotUnequal: 'Quell- und Ziel-Lager dürfen nicht identisch sein!'
  };

  public depotforStock = (item: Stock) => {
    if (!item) {
      return "";
    }

    return item.depot.label + (item.depot_yard ? ", " + item.depot_yard.label : '') + (item.identities && item.identities[0] ? ' (EAN: ' + item.identities[0].ean + ')' : '');
  };

  @Input()
  control: FormGroup;

  formHorizontal: boolean = true;

  //TODO: Refactor Apollo 2.0
  private stocksList$: ApolloQueryObservable<FetchStocksInDepotsQuery>;
  private watchQuery: Observable<any>;

  private _stocksList: Stock[];

  set stocksList(value: Stock[]) {
    this._stocksList = value || [];
    this.rows = this.stocksList;

    if (!this.control) {
      this.control = MoveStocksListComponent.initControl(this.fb);
    }
    this.control.setControl('data', MoveStocksListComponent.initStocksDataControl(this.fb, this.stocksList));

  }

  get stocksList(): Stock[] {
    return this._stocksList;
  }

  messages = {
    emptyMessage: this.getMessage.apply(this),
    totalMessage: 'Bestände insgesamt'
  };


  srcAdminUnitCuid$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  tgtAdminUnitCuid$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder, private stockService: StockService) {
    super(sessionActions, cd);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (!this.control) {
      this.control = MoveStocksListComponent.initControl(this.fb);
    }

    if (!this.searchTerm) {
      this.searchTerm = this.fb.control(null);
    }

    this.addSubscription(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'label', name: 'Bezeichner'},
      {prop: 'depot_yard.label', name: 'Quell-Lagerplatz'},
      {prop: 'act_stock', name: 'Quell-Ist-Bestand'},
      {prop: 'related_stocks.0.act_stock', name: 'Ziel-Ist-Bestand'},
      {name: 'Anzahl', cellTemplate: this.amountTmpl},
      {name: 'Ziel-Lagerplatz', cellTemplate: this.targetStockTmpl},
    ];

    //TODO: Refactor Apollo 2.0
    this.watchQuery = this.control.get('source_depot_cuid').statusChanges
      .pipe(
        combineLatest(this.control.get('target_depot_cuid').statusChanges, (src, target) => [src, target]),
        switchMap(status => {
          if (status[0] == 'VALID' && status[1] == 'VALID') {
            this.stocksList$ = this.stockService.getStocksInDepots(this.control.get('source_depot_cuid').value, this.control.get('target_depot_cuid').value);
            this.isLoading = true;
            return this.stocksList$.observableResult();
          } else {
            this.stocksList = [];
            this.isLoading = false;
            return empty();
          }
        }));

    this.addComponentData(this.stocksList$);
    this.addSubscription(this.watchQuery.subscribe(res => {
      this.isLoading = res.loading ? res.loading : false;
      this.stocksList = res.data.stocksInDepots;
    }));

  }

  private markRowAsDanger(row: Stock) {

    const cls = {};

    if (!this.control || !this.control.get('data')) {
      return cls;
    }

    const amount = AbstractVisbosComponent.getFormGroupById(this.control.get('data') as FormArray, row.cuid, 'source_stock_cuid').get('amount').value;

    if (row.act_stock < amount) {
      cls['warning'] = true;
    } else {
      cls['warning'] = false;
    }

    return cls;
  }

  public static initControl(fb: FormBuilder): FormGroup {
    const group = fb.group({
      source_admin_unit_cuid: [null],
      target_admin_unit_cuid: [null],
      source_depot_cuid: [null, Validators.required],
      target_depot_cuid: [null, [Validators.required, unequalTo('source_depot_cuid')]],
      rearrangement_note: [null],
      data: fb.array([], Validators.required),
      auth_data: MedicineAuthFormComponent.initControl(fb),
      generate_vouchers: fb.control(false)
    });

    return group;
  }

  private static initStocksDataControl(fb: FormBuilder, stocks: Stock[]): FormArray {
    const ctrl = fb.array([]);

    for (let st of stocks) {
      const targetStock = st.related_stocks && st.related_stocks.length == 1 ? st.related_stocks[0].cuid : null;
      const stCtrl = fb.group({
        source_stock_cuid: [st.cuid],
        target_stock_cuid: [targetStock],
        amount: [null]
      });

      stCtrl.get('target_stock_cuid').setValidators(requiredIfOtherFieldNotNull('amount'));

      // Required, so target stock cuid field gets validated whenever the amount field is changed:
      stCtrl.get('amount').setValidators([Validators.min(0), requiredIfOtherFieldNotNullReverse('target_stock_cuid')]);

      ctrl.push(stCtrl);
    }

    return ctrl;
  }

  getMessage() {
    return this.selectedDepotsValid() ? 'Keine Bestände vorhanden, die vom Quell-Lager in das Ziel-Lager verschoben werden können!' :
      'Bitte wählen Sie ein gültiges Quell- und Ziel-Lager aus!';
  }

  selectedDepotsValid(): boolean {
    return this.control && this.control.get('source_depot_cuid').valid && this.control.get('target_depot_cuid').valid;
  }

  movedStocksList() {
    const val = _.assign({}, this.control.value);
    val.data = val.data.filter(d => d.amount && d.amount > 0);
    return val;
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.stocksList;
    } else {
      if (this.stocksList) {
        this.rows = this.stocksList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  srcAdminUnitSelected(adminUnit) {
    this.srcAdminUnitCuid$.next(adminUnit ? adminUnit.cuid : null);
  }

  tgtAdminUnitSelected(adminUnit) {
    this.tgtAdminUnitCuid$.next(adminUnit ? adminUnit.cuid : null);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/components/move-stocks-list/move-stocks-list.component.ts